module.exports = __webpack_public_path__ + "static/img/5.1d20832.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chongqing/5.jpg
// module id = LpEP
// module chunks = 1